import { CaseStyle } from '@mews/enums';
import { createRepositoryRegistryFromFactories, sendRequest } from '@mews/framework/data-access';
import { distributorRestRepositoryFactories } from './generated/sdk/distributor/rest';
import { generalRestRepositoryFactories } from './generated/sdk/general/rest';

type GetOptions = () => {
    baseUrl: string;
    credentials?: RequestCredentials;
    commonParams: CommonRepositoryParams;
    correlationId?: string;
};

export interface CommonRepositoryParams {
    client: string;
    session: string;
}

const defaultCustomHeaders = {
    'X-Accept-Casing': CaseStyle.Camel,
};

const createOptions = (getOptions: GetOptions) => ({
    request: async <T>(url: string, params: T) => {
        const { baseUrl, commonParams, credentials, correlationId } = getOptions();

        const fullParams = {
            ...commonParams,
            ...params,
        };
        return sendRequest(
            `${baseUrl}${url}`,
            {
                credentials,
                customHeaders:
                    correlationId != null
                        ? { ...defaultCustomHeaders, 'X-Mews-CorrelationId': correlationId }
                        : { ...defaultCustomHeaders },
            },
            fullParams
        );
    },
});

export const createRepositoryRegistry = ({
    getDistributorOptions,
    getGeneralOptions,
}: {
    getDistributorOptions: GetOptions;
    getGeneralOptions: GetOptions;
}) => {
    const distributorRegistry = createRepositoryRegistryFromFactories(
        distributorRestRepositoryFactories,
        createOptions(getDistributorOptions)
    );
    const generalRegistry = createRepositoryRegistryFromFactories(
        generalRestRepositoryFactories,
        createOptions(getGeneralOptions)
    );

    return {
        ...distributorRegistry,
        ...generalRegistry,
    };
};

export type RepositoryRegistry = ReturnType<typeof createRepositoryRegistry>;
